<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="productRequirementHeaders"
        :items="admin.productRequirementList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.productRequirementList.length == 0"
        :hide-default-header="admin.productRequirementList.length == 0"
      >
        <template v-slot:item.childProductTypeId="{ item }">
          {{ getProductTypeName(item.childProductTypeId) }}
        </template>
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeName(item.attributeId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProductRequirement"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        productRequirementHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'CHILD', value: 'childProductTypeId' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'REQUIREMENT TYPE', value: 'requirementType' },
          { text: 'VALUE', value: 'value' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProductRequirementSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProductRequirementSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getProductRequirementList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given productId
       */
      getAttributeName(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * returns the product type name
       */
      getProductTypeName(productTypeId) {
        return this.admin.productTypeList.find((x) => x.id == productTypeId)
          ?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Product Attribute to currently selected product
       */
      addNewProductRequirement() {
        this.$store.commit('admin/setSelectedProductRequirement', {
          id: 'new',
          productId: 0,
          childProductTypeId: 0,
          attributeId: 0,
          requirementType: '',
          value: ''
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedProductRequirement', data.item);
          this.$store.dispatch(
            'admin/getAttributeValueList',
            data.item.attributeId
          );
        } else {
          this.$store.commit('admin/setSelectedProductRequirement', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProductRequirementSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
